import { useNavigate } from "react-router";
import { LCheckbox } from "@components";
import { FormProvider, useForm } from "react-hook-form";
import { StartAssessmentStepNames } from "../../../../store/startAssessmentSlice";
import { useModal } from "@services/ModalContext";
import { yupResolver } from "@hookform/resolvers/yup";
import { array, bool, object } from "yup";
import { useEffect } from "react";
import { NavItems } from "@helpers/navigation";

const formSchema = object({
    checklist: array().of(bool().required().isTrue("Check it"))
});

export const Checklist = (): JSX.Element => {
    const navigate = useNavigate();
    const validateMethods = useForm({
        resolver: yupResolver(formSchema)
    });
    const { setFormName } = useModal();

    useEffect(() => {
        setFormName?.(StartAssessmentStepNames.Checklist);
    }, []);

    const handleOnSubmit = (): void => {
        navigate(NavItems.Assessments.AssessmentChecks.path);
    };

    const renderCheckList = (): JSX.Element => {
        const checklistItems = [
            "Has been instructed to only say the words presented or requested with a brief pause in between",
            "Has been instructed to not engage in out-loud conversation/thinking",
            "Has used the restroom, if needed",
            "Is comfortable. Do they need a sweater, a more comfortable chair, etc?",
            "Has any necessary reading glasses with them",
            "Has their hearing aid turned up, if necessary",
            "Has turned off or silenced their cell phone",
            "Understands the assessment will take about 20 minutes and to do their best",
            "Understands that notes taking is not allowed"
        ];

        return (
            <FormProvider {...validateMethods}>
                <form id={StartAssessmentStepNames.Checklist} onSubmit={validateMethods.handleSubmit(handleOnSubmit)}>
                    <div className="mt-6 mb-5">
                        {checklistItems.map((item, i) => {
                            return (
                                <div
                                    key={`checkbox-${i}`}
                                    className="columns is-full is-flex is-flex-direction-row is-justify-content-space-between my-5 is-align-items-center"
                                >
                                    <div>{item}</div>
                                    <LCheckbox inputName={`checklist.${i}`} hideErrorLabel classes="ml-4 pl-6" />
                                </div>
                            );
                        })}
                    </div>
                </form>
            </FormProvider>
        );
    };

    return (
        <div className="container has-text-centered">
            <div className="mw-60 has-text-left">{renderCheckList()}</div>
        </div>
    );
};
